import { render } from "./SocialEducation.vue?vue&type=template&id=1046cbfc&ts=true"
import script from "./SocialEducation.vue?vue&type=script&lang=ts"
export * from "./SocialEducation.vue?vue&type=script&lang=ts"

import "./SocialEducation.vue?vue&type=style&index=0&id=1046cbfc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__